import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { CloseButton, useT } from '@repo/common';
import ApplyInfo from '../../../JobBoard/Apply/ApplyInfo';
import Resume from '../../../JobBoard/Apply/Resume';
import AdditionalUpload from '../../../JobBoard/Apply/AdditionalUpload';
import BottomButton from '../../../JobBoard/Apply/BottomButton';
import JobCompanyLogo from '../../../JobBoard/JobCompanyLogo';
import { getApplicationDetail } from '../../../../api/jobboard/apply.api';

const ApplicationHistoryModal = ({ job, isOpen, onClose, onDelete, $isMobile }) => {
  const navigate = useNavigate();
  const t = useT();
  const [detail, setDetail] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen || !job?.jobId) return;
    let active = true;
    setDetail(null);
    setFailed(false);
    getApplicationDetail(job.jobId).then((data) => {
      if (active) setDetail(data);
    }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, [isOpen, job?.jobId]);

  if (!isOpen) return null;
  const uploadData = {
    files: (detail?.files || []).map((file) => ({
      id: file.id,
      isExisting: true,
      fileUrl: file.fileUrl,
      file: { name: file.fileName, size: Number(file.fileSize), type: file.fileContentType },
    })),
    links: detail?.links || [],
  };

  return ReactDOM.createPortal(
    <div className='fixed inset-0 z-[1000000] flex items-stretch justify-center bg-grayscale-gray01 tabletH:items-center tabletH:p-[40px] tabletH:bg-surface-black60' onClick={onClose}>
      <div role='dialog' aria-modal='true' aria-label={t('Application details', '지원서 상세')} className='w-full h-full flex flex-col bg-grayscale-gray01 tabletH:w-[760px] tabletH:h-auto tabletH:max-h-full tabletH:rounded-[30px]' onClick={(event) => event.stopPropagation()}>
        <div className='flex shrink-0 justify-between items-center px-4 py-3 tabletH:px-[30px] tabletH:py-6 border-b border-grayscale-gray02'>
          <h2 className='typo-b16Strong text-text-primary'>{t('Application details', '지원서 상세')}</h2>
          <CloseButton type='default' onClick={onClose} />
        </div>
        <div className='flex flex-col min-h-0 overflow-y-auto px-4 py-6 tabletH:px-[30px] gap-6'>
          <button type='button' className='flex items-center gap-4 text-left' onClick={() => navigate('/jobs/' + job.jobId)}>
            <JobCompanyLogo src={job.companyLogoUrl} backgroundClassName='bg-grayscale-gray00' sizeClassName='size-[46px] tabletH:size-[60px]' padding='p-2' />
            <span className='flex flex-col gap-1 text-text-primary'>
              <span className='typo-b14'>{job.companyName}</span>
              <span className='typo-b16Strong'>{job.title}</span>
            </span>
          </button>
          {failed ? <p role='alert'>{t('Unable to load the application. Please reopen it to try again.', '지원서를 불러오지 못했습니다. 닫은 후 다시 열어 주세요.')}</p> : !detail ? <p>{t('Loading…', '불러오는 중…')}</p> : (
            <>
              <ApplyInfo status='view' value={detail} $isMobile={$isMobile} />
              <Resume status='view' selectedResume={detail.resume} $isMobile={$isMobile} />
              <AdditionalUpload status='view' job={job} files={uploadData.files} links={uploadData.links} isMyPage $isMobile={$isMobile} />
            </>
          )}
        </div>
        <BottomButton view='apply' status='view' onClose={onClose} onDelete={onDelete} uploadData={uploadData} $isMobile={$isMobile} />
      </div>
    </div>, document.body,
  );
};
export default ApplicationHistoryModal;
